import styled from 'styled-components';

const Footer = styled.footer`
  position: ${({ positionRelative }) => (positionRelative ? 'relative' : 'absolute')};
  bottom: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-top: 1px solid var(--gray-lighter);
`;

export default {
  Footer
};
